import { useEffect, useState } from "react";
import { Cake, CheckCheck } from "lucide-react";
import { toast } from "sonner";

import { api } from "@/api";
import { useAuth } from "@/auth";

export const StaffBirthdayPopup = () => {
  const { user } = useAuth();
  const canSee = ["admin", "responsabile", "coordinatore_commerciale"].includes(user.role);
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!canSee) return;
    api.get("/notifications/birthdays/popup").then(({ data }) => setItems(data)).catch(() => null);
  }, [canSee]);
  if (!items.length) return null;
  const markRead = async () => {
    setBusy(true);
    try {
      await Promise.all(items.map((item) => api.post(`/notifications/${item.id}/read`)));
      setItems([]);
    } catch {
      toast.error("Impossibile segnare come letto: riprova");
    } finally { setBusy(false); }
  };
  return <div className="modal-backdrop" data-testid="staff-birthday-popup" style={{ zIndex: 60 }}>
    <div className="completion-modal birthday-modal">
      <div className="section-heading"><div><p className="eyebrow">SQUADRA</p><h2 data-testid="staff-birthday-title">Compleanni di oggi</h2></div><Cake size={22} /></div>
      <p className="birthday-subtitle" data-testid="staff-birthday-subtitle">Questo avviso resta visibile finché non lo segni come letto.</p>
      <ul className="birthday-list" data-testid="staff-birthday-list">
        {items.map((item, index) => <li key={item.id} data-testid={`staff-birthday-item-${index}`}>
          <strong>{item.title}</strong>
          <span>{item.message}</span>
        </li>)}
      </ul>
      <div className="modal-actions"><button data-testid="staff-birthday-mark-read" className="primary-button" type="button" disabled={busy} onClick={markRead}><CheckCheck size={16} />{busy ? "Salvataggio…" : "Segna come letto e chiudi"}</button></div>
    </div>
  </div>;
};

export default StaffBirthdayPopup;
